import container from '../services/Container';

export default class MutationService {

	/**
	 * @return {Mutation}
	 */
	static getMutation() {
		return container.state.ui.mutation;
	}

	/**
	 * @return {string}
	 */
	static getMutationCode() {
		return MutationService.getMutation().code;
	}

	/**
	 * @return {Currency}
	 */
	static getDefaultMutation() {
		return container.state.ui.defaultMutation;
	}

	/**
	 * @param {object} mutations
	 * @return {?Mutation}
	 */
	static findDefaultMutation(mutations) {
		return mutations.find((mutation) => (mutation.default === true));
	}

	/**
	 * @param {string} code
	 * @param {object} [state]
	 *
	 * @return {?Currency}
	 */
	static findMutationByCode(code, state) {
		if (!code) {
			return null;
		}
		return MutationService.getMutations(state).find((mutation) => (code === mutation.code));
	}

	/**
	 * @param {object} [state]
	 *
	 * @return {Currency[]}
	 */
	static getMutations(state) {
		state = state || container.state;
		return state.mutations.items;
	}
}


// WEBPACK FOOTER //
// ./services/MutationService.js